"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslitMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ui_1 = require("@jsonjoy.com/ui");
const Sidetip_1 = require("@jsonjoy.com/ui/lib/1-inline/Sidetip");
const keys_1 = require("../util/keys");
const language_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/language"));
const keyboard_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/keyboard"));
const circle_off_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/circle-off"));
const map_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/map"));
const SHOW_MAPS_KEYS = ['Primary', 'Alt', 'Shift', 't'];
const SHOW_MAPS_KEYS_FORMATTED = (0, keys_1.formatKeys)(SHOW_MAPS_KEYS);
const TranslitIcon = (props) => (React.createElement(language_1.default, { width: 16, height: 16, ...props }));
const SchemeIcon = (props) => (React.createElement(keyboard_1.default, { width: 16, height: 16, ...props }));
const OffIcon = (props) => React.createElement(circle_off_1.default, { width: 16, height: 16, ...props });
const MapIcon = (props) => React.createElement(map_1.default, { width: 16, height: 16, ...props });
/** Split `"Russian (translit)"` into `["Russian", "translit"]`. */
const splitName = (name) => {
    const m = /^(.+?)\s*\(([^)]+)\)\s*$/.exec(name);
    if (!m)
        return [name, null];
    return [m[1], m[2]];
};
class TranslitMenu {
    constructor(translit) {
        this.translit = translit;
    }
    start() {
        return () => { };
    }
    build() {
        const t = this.translit;
        const active = ui_1.rsync.comp([t.active], ([id]) => !!id);
        const offItem = {
            name: 'Off',
            text: 'disable turn off translit',
            icon: () => React.createElement(OffIcon, null),
            active: ui_1.rsync.comp([t.active], ([id]) => !id),
            onSelect: () => {
                t.off();
            },
        };
        const showMapsItem = {
            name: 'Show maps',
            text: 'show maps overlay help mapping reference table cheatsheet',
            icon: () => React.createElement(MapIcon, null),
            keys: [SHOW_MAPS_KEYS_FORMATTED],
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, SHOW_MAPS_KEYS_FORMATTED),
            onSelect: () => {
                t.openMap();
            },
        };
        const schemeItems = t.list().map((scheme) => {
            const [label, suffix] = splitName(scheme.name);
            return {
                id: `translit:${scheme.id}`,
                name: label,
                text: `${scheme.id} ${scheme.language} ${scheme.script} ${scheme.name} translit phonetic`,
                icon: () => React.createElement(SchemeIcon, null),
                right: suffix ? () => React.createElement(Sidetip_1.Sidetip, { small: true }, suffix) : void 0,
                active: ui_1.rsync.comp([t.active], ([id]) => id === scheme.id),
                onSelect: () => {
                    t.toggle(scheme.id);
                },
            };
        });
        return {
            name: 'Transliteration',
            text: 'translit transliteration phonetic input language keyboard cyrillic',
            icon: () => React.createElement(TranslitIcon, null),
            active,
            children: [...(t.active.value ? [offItem] : []), showMapsItem, { name: 'sep-translit', sep: true }, ...schemeItems],
        };
    }
}
exports.TranslitMenu = TranslitMenu;
